/**
 * Sort order when pre-populating a stock take with uncounted items from Typesense
 */
export enum StockTakePopulationSortOrder {
  oldestCountedDate = 'oldestCountedDate',
  description = 'description',
}
